import React, { useEffect, useState } from 'react'
import CartTemplate from '../../components/template/CartTemplate/CartTemplate'
import { api, getApiClient } from '../../utils'
import {
  CARRELLOMAIN,
  SVUOTA,
  MOVETOLATER,
  PERSONALIZZAZIONICARRELLO,
  RIGHECARRELLO,
  ADDTOMAIN,
  PAGINEDETAIL,
} from '../../utils/endpoint'
import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { QuantitaContext } from '../../context/QuantitaContext'
import { CartContext } from '../../context/CartContext'
import CartPopup from '../../components/organisms/CartPopup/CartPopup'
import { useRouter } from 'next/router'
import { createToken } from './checkout/[token]'
import Loading from '../../components/atoms/Loading/Loading'
import { displayNotification } from '../../components/atoms/Notifica/Notifica'
import { MetaSeo } from '../../components'
import useTrans from '../../hooks/useTrans'
import { FetchCarrelloLater, getError } from '../../utils/cart'
import { LoghiMancantiModal } from '../../components/organisms/CartAlerts/CartAlerts'
import _ from 'lodash'
import * as Sentry from '@sentry/browser'
import { trackingCartView } from '../../utils/gtm'

const CartPage = ({ page }) => {
  const router = useRouter()
  const t = useTrans()

  const { setCartMain, cartMain } = useContext(CartContext)
  const { quantita, resetAllQuantita } = useContext(QuantitaContext)
  const { utente } = useSelector((state) => state.utente)

  const [carrelloMain, setCarrelloMain] = useState(null)
  const [firstFetch, setFirstFetch] = useState(true)
  const [loadingMain, setLoadingMain] = useState(false)
  const [loadingLater, setLoadingLater] = useState(false)
  const [disabledCheckout, setDisabledCheckout] = useState(true)
  const [content, setContent] = useState([])
  const [steps, setSteps] = useState(null)
  const [loghiMancanti, setLoghiMancanti] = useState([])
  const [carrelloMainError, setCarrelloMainError] = useState(false)
  const [showCartPopup, setShowCartPopup] = useState({
    quantita_minima_personalizzabile: true,
    merce_mista: true,
    loghi: true,
    blocco_utente: true,
  })
  const [carrelloLater, setCarrelloLater] = useState(null)
  const [tracked, setTracked] = useState(false)

  const handleMultiCheckout = (steps) => {
    const carrelliNonProcessati = steps?.filter((step) => step?.processato === false)
    if (carrelliNonProcessati.length > 0) {
      if (utente) {
        router.push(`/cart/checkout/${createToken(carrelliNonProcessati[0]?.id)}`)
      } else {
        router.push(
          `/myaccount/accedi?next=/cart/checkout/${createToken(carrelliNonProcessati[0]?.id)}`
        )
      }
    }
  }

  const FetchCarrelloMain = async () => {
    firstFetch && setLoadingMain(true)
    const response = await api
      .get(CARRELLOMAIN, { params: { lang: router.locale } })
      .catch((err) => {
        Sentry.captureException(err)
        if (err.toString().includes('500')) {
          setCarrelloMainError(true)
        }
        setDisabledCheckout(true)
      })

    if (response?.data) {
      setCarrelloMain(response.data)
      setCartMain(response.data)

      // se le modali dei loghi mancanti sono aperte, al cambio del carrello aggiorno anche le modali
      if (loghiMancanti?.length > 0) {
        checkLoghiMancanti(response.data)
      }
    }

    firstFetch && setLoadingMain(false)
    firstFetch && setFirstFetch(false)
  }

  const EliminaPersonalizzazione = async (righe_id) => {
    try {
      await righe_id.forEach((riga) =>
        api
          .put(RIGHECARRELLO + riga.id + '/', {
            personalizzazione_carrello_id: null,
            quantita: riga?.quantita,
            articolo_id: riga?.articolo_id,
            lang: router.locale,
          })
          .catch((err) => {
            Sentry.captureException(err)
          })
      )

      FetchCarrelloMain()
      FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
    } catch (error) {
      displayNotification('remove.personalizzazione', t('Personalizzazione Rimossa con Successo'))
    }
  }

  const updateNota = async (nota, id) => {
    const params = {
      nota: nota,
      lang: router.locale,
    }
    await api.patch(`${RIGHECARRELLO}${id}/`, params).then((response) => {
      FetchCarrelloMain()
      FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
    })
  }

  const updateNomeLavorazione = async (nomeLavorazione, id) => {
    const params = {
      nome_lavorazione: nomeLavorazione,
    }
    try {
      await api.put(`${PERSONALIZZAZIONICARRELLO}${id}/`, params).then((response) => {
        FetchCarrelloMain()
        FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
      })
    } catch (err) {
      displayNotification(
        'error.nome-lavorazione.edit',
        getError(err, t('Qualcosa è andato storto')),
        'error'
      )
    }
  }

  useEffect(() => {
    resetAllQuantita()

    FetchCarrelloMain()
    FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
    api.get('carrelli/checkout/').catch((err) => Sentry.captureException(err)).then((result) => setSteps(result?.data?.steps))
    
  }, [])

  useEffect(() => {
    setContent([])
    checkErroriCarrello()
  }, [carrelloMain])

  const checkErroriCarrello = () => {
    if (carrelloMain && carrelloMain?.errori) {
      const _check = carrelloMain?.errori.filter((errore) => errore.bloccante)
      _check.length > 0 ? setDisabledCheckout(true) : setDisabledCheckout(false)
    }
  }

  const MoveToMain = async (id) => {
    setLoadingMain(true)
    await api
      .post(`${RIGHECARRELLO}${id}/${ADDTOMAIN}`, { params: { lang: router.locale } })
      .then((response) => {
        FetchCarrelloMain().then(() => setLoadingMain(false))
        FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
      })
      .catch((err) => {
        setLoadingMain(false)
        displayNotification(
          'error.cart.movetomain',
          getError(err, t('Qualcosa è andato storto')),
          'error'
        )
      })
  }

  const MoveToLater = async (id) => {
    setLoadingMain(true)
    await api
      .post(`${RIGHECARRELLO}${id}/${MOVETOLATER}`, { params: { lang: router.locale } })
      .then((response) => {
        FetchCarrelloMain().then(() => setLoadingMain(false))
        FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
      })
      .catch((err) => {
        setLoadingMain(false)
        displayNotification(
          'error.cart.movetolater',
          getError(err, t('Qualcosa è andato storto')),
          'error'
        )
      })
  }

  const Delete = async (id) => {
    await api
      .delete(`${RIGHECARRELLO}${id}/`, { params: { lang: router.locale } })
      .then(async (response) => {
        await FetchCarrelloMain()
        await FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
      })
  }

  const UpdateQuantita = async (riga_id, codice) => {
    try {
      setLoadingLater(true)
      const obj_quantita = quantita.filter((articolo) => articolo.codice === codice)[0]
      if (!codice) {
        throw new Error(t('Qualcosa è andato storto'))
      }
      const params = {
        quantita: obj_quantita?.quantita,
        prossimi_arrivi_ids: obj_quantita?.prossimi_arrivi?.map(({ id }) => id),
        lang: router.locale,
      }

      await api
        .patch(`${RIGHECARRELLO}${riga_id}/`, params)
        .then((response) => {
          FetchCarrelloMain()
          FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
          setLoadingLater(false)
          displayNotification(
            'success.cart.edit',
            t("Hai modificato la quantità dell'articolo {0}", [codice])
          )
        })
        .catch((err) => {
          setLoadingLater(false)
          displayNotification('error.cart.edit', getError(err, t('Qualcosa è andato storto')))
        })
    } catch (error) {
      displayNotification('error.codice.edit', error.message)
      setLoadingLater(false)
    }
  }

  const MoveToLaterPersonalizzazione = async (id) => {
    setLoadingMain(true)
    await api
      .post(`${PERSONALIZZAZIONICARRELLO}${id}/${MOVETOLATER}`, { params: { lang: router.locale } })
      .then((response) => {
        FetchCarrelloMain().then(() => setLoadingMain(false))
        FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
      })
      .catch((err) => {
        setLoadingMain(false)
        displayNotification(
          'error.cart.movetolaterpersonalizzazione',
          getError(err, t('Qualcosa è andato storto')),
          'error'
        )
      })
  }

  // Nuova funzione per fare Check dei loghi mancanti e fare Trigger delle Modal
  const checkLoghiMancanti = (carrello) => {
    const _erroriLoghi = carrello?.errori?.filter((errore) => errore.tipo === 'no_logo_pantoni')
    _erroriLoghi?.length > 0 &&
      setLoghiMancanti(
        _erroriLoghi?.map((logo, i) => ({
          ...logo,
          visibile: i === 0 ? true : false,
        }))
      )

    return _erroriLoghi
  }

  // ! Questa funzione viene chiamata dentro la RiepilogoCard Permettendo di controllare se son Presenti degli Errori
  // TODO una volta inserita tutta la logica del Cart -> Dovrà essere integrato l'ordine e il redirect verso /cart/checkout
  const onCheckout = () => {
    const {
      personalizzazioni_carrello,
      righe_carrello_merce_neutra,
      checkout_abilitato,
      errori,
      steps,
    } = carrelloMain

    if (checkLoghiMancanti(carrelloMain).length === 0) {
      const new_content = [...content]
      const addContent = (array, string) => !array.includes(string) && array.push(string)
      const removeContent = (array, string) => array.includes(string) && array.pop(string)

      steps?.length > 1 && checkout_abilitato && addContent(new_content, 'merce_mista')

      !checkout_abilitato && addContent(new_content, 'blocco_utente')

      // ? Controllo che la quantità minima personalizzabile sia rispettata
      carrelloMain?.errori?.filter((errore) => errore?.tipo === 'quantita_minima_personalizzabile')
        ?.length > 0
        ? addContent(new_content, 'quantita_minima_personalizzabile')
        : removeContent(new_content, 'quantita_minima_personalizzabile')

      // ! Mi serve un dato per fare il check che i loghi siano stati caricati!

      setShowCartPopup({
        quantita_minima_personalizzabile: true,
        blocco_utente: true,
        merce_mista: true,
        loghi: true,
      })

      setContent(new_content)

      // ! Nel caso new_content fosse vuoto proseguire verso la pagina di Checkout
      // Da fare solo una volta completato tutto il Cart e la roba dei loghi

      if (
        new_content.length === 0 &&
        carrelloMain &&
        checkLoghiMancanti(carrelloMain).length === 0
      ) {
        if (utente) {
          router.push(`/cart/checkout/${createToken(carrelloMain?.id)}`)
        } else {
          router.push(`/myaccount/accedi?next=/cart/checkout/${createToken(carrelloMain?.id)}`)
        }
      }

      // TODO inserire un ulteriore check sugli Errori -> Come il numero di articoli nel carrello > 0
    }
  }

  //Questa funzione permette di chiudere il CustomModal di quel singolo componente specifico nel Map
  const closePopup = (value, content) => {
    const new_showCartPopup = Object.assign({}, showCartPopup)
    new_showCartPopup[content] = false
    setShowCartPopup(new_showCartPopup)
  }

  // ! Questa funzione sposta tutti le personalizzazione nei salvati per Dopo per Proseguire verso il checkout con le merci Neutre
  // Viene chiamata quando si fa il Click su Prosegui
  const AddToLater_All = () => {
    const { personalizzazioni_carrello } = carrelloMain
    personalizzazioni_carrello.length > 0 &&
      personalizzazioni_carrello.forEach((personalizzazione) =>
        MoveToLaterPersonalizzazione(personalizzazione.id)
      )
    // ! Una volta spostati tutti gli elementi aggiorna il carrello e setta il Content a [] così da poter procedere
    FetchCarrelloMain()
    setContent([])
  }

  const OrdinaSubito = async () => {
    router.push(`/cart/checkout/${createToken(carrello?.id)}`)
  }

  const MoveToMainPersonalizzazione = async (id) => {
    setLoadingMain(true)
    await api
      .post(`${PERSONALIZZAZIONICARRELLO}${id}/${ADDTOMAIN}`, { params: { lang: router.locale } })
      .then((response) => {
        FetchCarrelloMain().then(() => setLoadingMain(false))
        FetchCarrelloLater(setLoadingLater, setCarrelloLater, router)
      })
      .catch((err) => {
        setLoadingMain(false)
        displayNotification(
          'error.cart.movetomainpersonalizzazione',
          getError(err, t('Qualcosa è andato storto')),
          'error'
        )
      })
  }

  const SvuotaCarrelloMain = async () => {
    setLoadingMain(true)
    await api
      .get(`${CARRELLOMAIN}${SVUOTA}`, { params: { lang: router.locale } })
      .then((response) => {
        setCarrelloMainError(false)
        FetchCarrelloMain().then(() => setLoadingMain(false))
      })
      .catch((err) => {
        setLoadingMain(false)
      })
  }

  useEffect(() => {
    if (carrelloMain && !firstFetch && !loadingMain && !tracked) {
      trackingCartView(carrelloMain)
      setTracked(true)
    }
  }, [carrelloMain, firstFetch, loadingMain])

  return (
    <>
      <MetaSeo seo={page.seo} />
      <div className="page">
        <CartTemplate
          EliminaPersonalizzazione={EliminaPersonalizzazione}
          disabledCheckout={carrelloMain?.numero_righe !== 0 ? disabledCheckout : true}
          onCheckout={onCheckout}
          loadingMain={loadingMain}
          loadingLater={loadingLater}
          carrello_main={carrelloMain}
          carrello_later={carrelloLater}
          MoveToLater={!loadingLater ? MoveToLater : undefined}
          MoveToMain={!loadingMain ? MoveToMain : undefined}
          Delete={Delete}
          updateNota={updateNota}
          updateNomeLavorazione={updateNomeLavorazione}
          UpdateQuantita={UpdateQuantita}
          MoveToLaterPersonalizzazione={!loadingLater ? MoveToLaterPersonalizzazione : undefined}
          MoveToMainPersonalizzazione={!loadingMain ? MoveToMainPersonalizzazione : undefined}
          checkErroriCarrello={FetchCarrelloMain}
          page={page}
          OrdinaSubito={OrdinaSubito}
          SvuotaCarrelloMain={SvuotaCarrelloMain}
        />

        {content.length > 0 &&
          content.map((_content, id) => (
            <CartPopup
              handleMultiCheckout={handleMultiCheckout}
              AddToLater_All={() => AddToLater_All()}
              content={_content}
              key={id}
              steps={carrelloMain?.steps}
              show={showCartPopup[_content]}
              closePopup={() => closePopup(false, _content)}
            />
          ))}
        {steps?.filter((step) => step.processato === false).length > 0 && (
          <CartPopup
            show={true}
            AddToLater_All={() => AddToLater_All()}
            key={'check_checkout_in_corso'}
            steps={steps}
            handleMultiCheckout={handleMultiCheckout}
            content={'checkout_sospeso'}
          />
        )}
        {carrelloMainError && (
          <CartPopup
            show={true}
            key={'clean_carrello'}
            steps={steps}
            handleMultiCheckout={handleMultiCheckout}
            content={'clean_carrello'}
            closePopup={() => setCarrelloMainError(false)}
            svuotaCarrelloMain={SvuotaCarrelloMain}
          />
        )}

        {loghiMancanti?.length > 0 && (
          <LoghiMancantiModal
            setLoghiMancanti={setLoghiMancanti}
            checkErroriCarrello={FetchCarrelloMain}
            loghiMancanti={loghiMancanti}
            cartMain={cartMain}
          />
        )}
      </div>
    </>
  )
}

export async function getServerSideProps({ locale, req }) {
  const api = getApiClient(req)
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'cart',
        lang: locale,
      },
    })
    const page = await pageResponse.data

    const toolbarProps = { toolbarPage: page }

    return { props: { page, ...toolbarProps } }
  } catch (error) {
    return {
      notFound: true,
    }
  }
}

export default CartPage
